import { api } from "./client";

export interface MeResponse { username: string; }

export const login = (username: string, password: string) =>
  api<MeResponse>("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });

export const logout = () =>
  api<{ ok: boolean }>("/api/auth/logout", { method: "POST" });

export const me = () => api<MeResponse>("/api/auth/me");
